import { gqlClient } from '@/api/graphql-client';
import materialKeys from '@/api/queries/materials/keyFactory';
import { graphql } from '@/gql';
import {
  RemoveAccountPreferredProductMutation as RemoveAccountPreferredProductMutationResult,
  Scalars,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const RemoveAccountPreferredProductMutation = graphql(`
  mutation RemoveAccountPreferredProduct($productId: ID!) {
    removeAccountPreferredProduct(productId: $productId)
  }
`);

const useRemoveAccountPreferredProduct = (
  options?: UseMutationOptions<
    RemoveAccountPreferredProductMutationResult,
    Error,
    Scalars['ID']['input']
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (productId) => {
      return gqlClient.request(RemoveAccountPreferredProductMutation, {
        productId,
      });
    },
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: materialKeys.accountPreferredProducts(),
      });
      void queryClient.invalidateQueries({
        queryKey: [...materialKeys.all, 'productSpecs'],
      });
    },
    ...options,
  });
};

export default useRemoveAccountPreferredProduct;
